import MainFrameContextType from "../../types/MainFrameContextType";
import React from "react";
import { Layout, Page } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import DataItem from "./DataItem";
import "./index.css";
import { MainFrameContext } from "../contexts/MainFrameContext";
import { useDispatch, useSelector } from "react-redux";
import { getInspectionById } from "../../store/actions/Inspections";
import {
    getFormattedDetails,
    InspectionDetail
} from "../../types/InspectionDetail";
import { PortalState } from "../../types/PortalState";
import SubmissionProgressHeader from "../SubmissionProgressHeader/SubmissionProgressHeader";
import { WarningBanner } from "../WarningBanner/WarningBanner";
import MarkAsCompleteModal from "../MarkAsCompleteModal/MarkAsCompleteModal";
import { AssetType } from "../../types/AssetType";

interface Props {
    id: string;
}

export default function InspectionDetails({ id }: Props) {
    const { t } = useTranslation("common");
    const { setShowSideBar } = React.useContext(
        MainFrameContext
    ) as MainFrameContextType;
    const currentInspection = useSelector(
        (state: PortalState) => state.portal.activeInspection
    );
    const [showMarkAsCompleteModal, setShowMarkAsCompleteModal] =
        React.useState(false);

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(getInspectionById(id));
        setShowSideBar(true);
    }, []);

    let details: InspectionDetail[] = [];
    let mainShipUrl = "/images/blank_mainshipimage.png";

    if (currentInspection !== undefined) {
        details = getFormattedDetails(currentInspection, t);
        mainShipUrl =
            currentInspection?.MainShipImage ||
            "/images/blank_mainshipimage.png";
    }

    function openModal() {
        setShowMarkAsCompleteModal(true);
    }

    return (
        <div style={{ height: "100" }}>
            {/* <Page title="Inspection Particulars" fullWidth> */}
            <MarkAsCompleteModal
                type={AssetType.Document}
                active={showMarkAsCompleteModal}
                closeModal={() => {
                    setShowMarkAsCompleteModal(false);
                }}
            />

            <SubmissionProgressHeader
                dueDate={currentInspection?.DueDate}
                surveyorCompletionStatus={
                    currentInspection?.SurveyorCompletionStatus}
                openModal={openModal}/> 

            <WarningBanner />
            <Page title={t("inspection.details.title")} fullWidth>
                {details.length === 0 ? (
                    <Layout.Section>
                        {t("inspection.details.loading")}
                    </Layout.Section>
                ) : (
                    <div className="inspectionContainer">
                        <div className="inspectionImageArea">
                            <div
                                className="mainShipImage"
                                style={{
                                    backgroundImage: "url(" + mainShipUrl + ")"
                                }}
                            />
                        </div>
                        <div className="inspectionDetailArea">
                            {details.map((item, idx) => (
                                <DataItem
                                    key={idx}
                                    title={item.title}
                                    value={item.value}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </Page>
        </div>
    );
}
